(() => {
  const formatMoney = (cents, currencyCode, showCurrencyCode) => {
    const amount = Number(cents) / 100;
    let formatted;

    try {
      formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(amount);
    } catch (error) {
      formatted = `$${amount.toFixed(2)}`;
    }

    return showCurrencyCode ? `${formatted} ${currencyCode || 'USD'}` : formatted;
  };

  const getSelectedVariantPrice = (productInfo) => {
    const selectedVariant = productInfo.querySelector('variant-selects [data-selected-variant]');

    if (!selectedVariant?.textContent.trim()) return Number(productInfo.dataset.lwesCurrentPrice || 0);

    try {
      const variant = JSON.parse(selectedVariant.textContent);
      return Number(variant?.price || productInfo.dataset.lwesCurrentPrice || 0);
    } catch (error) {
      return Number(productInfo.dataset.lwesCurrentPrice || 0);
    }
  };

  const applyStorewideDiscountPrice = (scope = document) => {
    const productInfos = scope.matches?.('product-info')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('product-info') || []);

    productInfos.forEach((productInfo) => {
      if (productInfo.dataset.lwesStorewideDiscountActive !== 'true') return;

      const percentage = Number(productInfo.dataset.lwesStorewideDiscountPercentage || 0);
      const currentPrice = getSelectedVariantPrice(productInfo);
      const priceWrapper = productInfo.querySelector(`#price-${productInfo.dataset.section}`);
      const priceElement = priceWrapper?.querySelector('.price');

      if (!priceWrapper || !priceElement || !currentPrice || !percentage) return;

      productInfo.dataset.lwesCurrentPrice = String(currentPrice);

      const discountFactor = 100 - percentage;
      const discountedPrice = Math.floor((currentPrice * discountFactor) / 100);
      const currencyCode = productInfo.dataset.lwesCurrencyCode || 'USD';
      const showCurrencyCode = productInfo.dataset.lwesCurrencyCodeEnabled === 'true';
      const originalText = formatMoney(currentPrice, currencyCode, showCurrencyCode);
      const discountedText = formatMoney(discountedPrice, currencyCode, showCurrencyCode);
      const compareAt = priceElement.querySelector('.price__sale .price-item--regular');
      const sale = priceElement.querySelector('.price__sale .price-item--sale');

      if (!compareAt || !sale) return;

      priceElement.classList.add('price--on-sale');

      if (compareAt.textContent.trim() !== originalText) {
        compareAt.textContent = originalText;
      }

      if (sale.textContent.trim() !== discountedText) {
        sale.textContent = discountedText;
      }
    });
  };

  window.LwesProductPricing = {
    apply: applyStorewideDiscountPrice,
  };

  const initLwesProductPricing = () => {
    applyStorewideDiscountPrice(document);

    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.dataset.lwesPricingReady === 'true') return;

      productInfo.dataset.lwesPricingReady = 'true';

      new MutationObserver(() => applyStorewideDiscountPrice(productInfo)).observe(productInfo, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  };

  const initLwesProductGallery = () => {
    const galleries = document.querySelectorAll('[data-lwes-product-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.lwesReady === 'true') return;

      const main = gallery.querySelector('[data-lwes-main-media]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-lwes-gallery-thumb]'));
      const templates = gallery.querySelector('[data-lwes-gallery-templates]');
      const currentCounter = gallery.querySelector('[data-lwes-gallery-current]');

      if (!main || !templates || !thumbs.length) return;

      gallery.dataset.lwesReady = 'true';

      const setActiveThumb = (index) => {
        thumbs.forEach((thumb) => {
          const isActive = Number(thumb.dataset.mediaIndex) === index;

          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const switchMedia = (index) => {
        const template = templates.querySelector(`[data-lwes-gallery-template="${index}"]`);

        if (!template) return;

        gallery.classList.add('is-switching');

        setActiveThumb(index);

        if (currentCounter) {
          currentCounter.textContent = String(index + 1);
        }

        window.setTimeout(() => {
          main.innerHTML = template.innerHTML;

          window.setTimeout(() => {
            gallery.classList.remove('is-switching');
          }, 90);
        }, 140);
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          switchMedia(Number(thumb.dataset.mediaIndex));
        });

        thumb.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            switchMedia(Number(thumb.dataset.mediaIndex));
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initLwesProductPricing();
    initLwesProductGallery();
  });

  document.addEventListener('shopify:section:load', () => {
    initLwesProductPricing();
    initLwesProductGallery();
  });
})();
